import { render, staticRenderFns } from "./LearningGoalGradeList.vue?vue&type=template&id=ae1e5b56&"
import script from "./LearningGoalGradeList.vue?vue&type=script&lang=js&"
export * from "./LearningGoalGradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports